import Tag from '../../tag/index';

export default class QuestionTag extends Tag {
  constructor(tag = {}, url) {
    super(tag, url);

    this.event_poll_id = tag.event_poll_id;
  }
}
